import React from "react";
import Navbar from "./Navbar";
import "./Activities.css";
const Activities = () => {
  return (
    <>
      <Navbar />

      <div className=" container gcekactivities">
        <div>
          <h2>
            Our <span>Activities</span>
          </h2>
          <h4>Discover The Thrill Of Adventure With Our Exciting Activities</h4>
        </div>

        <div className="row features-items gcekactivitieslist">
          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-tv"></i>
              </div>
              <div className="info">
                <h4>Theory Class</h4>
                <p>
                  GCEK Naval NCC do Theory class on both common subject and
                  service subject.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-water"></i>
              </div>
              <div className="info">
                <h4>Drill</h4>
                <p>
                  We trained our cadets with drills. We taught both army and
                  navy drill.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-mountain"></i>
              </div>
              <div className="info">
                <h4>Mountain Trekking</h4>
                <p>
                  We do mountain trekking near to our college mountains in
                  Bhawanipatna
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-ship"></i>
              </div>
              <div className="info">
                <h4>Boat Pooling</h4>
                <p>
                  Boat Pooling training is provided to the cadets by the unit
                  and in national camps
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-volleyball-ball"></i>
              </div>
              <div className="info">
                <h4>SPORTS</h4>
                <p>Our Cadets play volleyball, bad minton, tugh of war etc.</p>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-fire"></i>
              </div>
              <div className="info">
                <h4>Firing</h4>
                <p>
                  Every Year our cadet gets a chance to fire a minimum of 5
                  rounds which is provided by our unit. Unit tought our cadet
                  the weapon traing every year.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-campground"></i>
              </div>
              <div className="info">
                <h4>Camps</h4>
                <p>
                  We provide a lot of camp like ATC, AINSC, RDC, NTAC, SYTC.
                  EBSB etc.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-ship"></i>
              </div>
              <div className="info">
                <h4>Ship Modelling</h4>
                <p>We taught our cadetsd how to model a ship.</p>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-globe"></i>
              </div>
              <div className="info">
                <h4>Cultural Events</h4>
                <p>
                  We provide a platform to our cadets to paticipate in various
                  cultural activities like singing, dancing etc.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-swimmer"></i>
              </div>
              <div className="info">
                <h4>Swimming</h4>
                <p>
                  We provide our cadets some camps where they can learn
                  swimming, and if someone is good in swimming we provide them a
                  platform to show their skill in national level.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-flag"></i>
              </div>
              <div className="info">
                <h4>Semaphore</h4>
                <p>
                  semaphore, method of visual signaling, usually by means of
                  flags or lights.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-water"></i>
              </div>
              <div className="info">
                <h4>Kayaking</h4>
                <p>
                  Kayaking is the use of a kayak for moving over water. It is
                  distinguished from canoeing by the sitting position of the
                  paddler and the number of blades on the paddle.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-water"></i>
              </div>
              <div className="info">
                <h4>Social Awareness</h4>
                <p>
                  We do social Awareness about Say No Drugs, Save Tree, Swach
                  Varat etc..
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-tree"></i>
              </div>
              <div className="info">
                <h4>Tree Plantation</h4>
                <p>
                  We Plant tree every year in our college campus and in
                  Bhawanipatna.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 equal-height activitiesitems">
            <div className="item">
              <div className="icon">
                <i className="fas fa-dumbbell"></i>
              </div>
              <div className="info">
                <h4>Yoga</h4>
                <p>
                  We do Yoga in every week to develop both physical and mental
                  health of our cadets
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Activities;
